import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { renderRoutes, matchRoutes } from "react-router-config";
import { connect } from "react-redux";
import { parse } from "query-string";
import { mapProperties, hydrateRoute } from "colbi_web_ui/lib/utils";

import Header from "colbi_web_ui/lib/components/layout/Header/Header";
import Connect from "colbi_web_ui/lib/components/Connect";

import MainTabs from "../App/MainTabs/MainTabs";

import { LoadingIndicator } from "colbi_web_ui/lib/components";

import {
    asideRepositoryNavigationByModule,
    filteredNavigationByModulesForNestedLinks,
} from "../Repository/navigation";

import styles from "./App.module.sass";

import {
    logout,
    pushModal,
    pushDialog,
    popModal,
    uploadAction,
    downloadAction,
    toggleMenu,
    setLocale,
    auditNoteSubmit,
    removeModal,
    setDataFileStatusAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    hideFileAction,
    downloadFileAction,
    reprocessRepositoryAction,
    genericSearchAction,
    getFindingDetails,
    reprocessFileAction,
    getDownloadTemplateData,
    deleteGeneratorFileEntryAction,
    forceGenerateFileAction
} from "../../store/actions";
import I18n from "../../I18n";

import proxy from "../../routes/proxy";
import {
    filteredQueriesByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
} from "../../routes/manageRouting";

import { submitTicketFormData } from "../../store/actions/modalActions";

import RepositoryStatus from "../../components/RepositoryStatus/RepositoryStatus";

import { changeDeepObject, mapPropertiesForMenu } from "../../utils";
import {
    decodeUserSession,
    redirectNotValid,
    buildStaticLinks,
    BuildSovosNavProps,
    setAccount,
} from "../../utils/utils";
import { cleanPropertiesNestedInMenu } from "../../utils/mapPropertiesForMenu";
import { urlRedirectLink } from "../../utils/routingUtils";
import GlobalLayout from "../../components/GlobalLayout";
import LoadingPage from "../Login/LoadingPage";
import { useAuth } from "react-oidc-context";

const Repository = (props) => {
    const {
        pushModal,
        modules,
        user,
        fetch,
        menu,
        setLocale,
        match,
        route,
        location,
        history,
        reload,
    } = props;
    const { params: matchParams } = match || {};
    let { fiscalYear, importId, section, fileType } = matchParams;
    const { projectId, modulePrefix, locale = "en" } = matchParams;
    const { results: fetchResults, status: fetchStatus } = fetch || {};

    const defaultContext = (match?.url || "").match("/repository/") ? "repository" : "";
    const [appContext, setAppContext] = useState(defaultContext);
    const filesList = useRef([]);
    const auth = useAuth();

    useEffect(() => {
        if ((match?.url || "").match("/repository/")) {
            setAppContext("repository");
        } else {
            setAppContext("");
        }
    }, [match]);

    const userInformation = decodeUserSession(user);

    const i18n = I18n.use(locale);

    const { menuOrganizationProject = [] } = mapProperties(
        {
            menuOrganizationProject: "query(0).list",
        },
        fetchResults,
        fetchStatus,
        Repository.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const { organizationProjects = {}, queryStatus } = mapProperties(
        {
            organizationProjects: "query(1)",
            queryStatus: "status(1)",
        },
        fetchResults,
        fetchStatus,
        Repository.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const getTotalExportLines = fetchResults[`${locale}_get_limit_export`] || "";

    const project = organizationProjects
        ? (organizationProjects.projects || []).find(({ id }) => id === projectId) || {
              name: "",
          }
        : { name: "" };

    const { fiscalYears: projectFiscalYears } = project || {};

    const fiscalYears = Object.keys(projectFiscalYears || []);

    if (!fiscalYear && project && projectFiscalYears) {
        fiscalYear = fiscalYears.length > 0 ? Math.max(...fiscalYears) : "";
    }

    const fiscalYearsWithImportIds = projectFiscalYears || {};
    const importIdsFromUrlFiscalYear = fiscalYearsWithImportIds[fiscalYear];

    if (!importId && importIdsFromUrlFiscalYear && importIdsFromUrlFiscalYear.length) {
        const [maxImportId] = importIdsFromUrlFiscalYear;
        importId = maxImportId?.id;
    }

    const repositoryStatus = fetchResults[
        `${locale}_repository_status_fiscalYear_${fiscalYear}_projectId_${projectId}`
    ] || { status: 1 };

    //############ Build Generic Menu  ############

    const queriesForMenu = filteredQueriesByModulesForMenu(modules);
    const navData = mapPropertiesForMenu(
        queriesForMenu,
        fetchResults,
        locale,
        fiscalYear,
        projectId,
        importId,
    );

    const firstModuleFromProject = getFirstModuleOfArray(modules);
    const moduleConfigs = project
        ? (project.modules || []).find(({ name }) => name === firstModuleFromProject)
        : undefined;
    const importIdToUse =
        moduleConfigs && moduleConfigs.navigation_by_import_id ? importId : "full";

    const params = {
        ...(parse(location.search) || {}),
        ...(matchParams || {}),
    };

    const routeQueries = (route.queries && route.queries(params)) || [];

    const genericOverview =
        fetchResults[
            `${locale}_generic_overview_fiscalYear_${fiscalYear}_importId_${importId}_locale_${locale}_modulePrefix_${modulePrefix}_projectId_${projectId}`
        ];

    const getLayout = JSON.parse(genericOverview || "[]");

    changeDeepObject(getLayout, ["component", "cards"], {
        SubmitSalesInfo: { projectData: projectFiscalYears },
    });

    let displayComponents = [];

    displayComponents.push(...route.components);

    if (getLayout.length > 0 && route && route.isOverview) {
        displayComponents.push(...getLayout);
    }

    const children = displayComponents.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            fetchResults,
            fetchStatus,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );
        const componentProps = {
            ...componentParsedProps,
            modules,
        };

        if (componentProps && componentProps.onClickPushModal) {
            const { view, title } = componentProps.onClickPushModal;
            componentProps.onClick = (e) => {
                e.originalEvent.preventDefault();
                e.originalEvent.stopPropagation();
                const data = e.target.value || {};
                pushModal({
                    title: i18n`${title}`,
                    data: {
                        projectId: params.projectId,
                        ...data,
                    },
                    args: { ...params, ...data },
                    view: `${view}Form`,
                })
                    .then(() => reload && reload())
                    .catch(() => null);
            };
        }

        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    });

    const title = mapProperties(
        { title: route.title },
        fetchResults,
        fetchStatus,
        routeQueries,
        props,
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    ).title;

    const branch = matchRoutes([route, ...(route.routes || [])], location.pathname);
    //TODO: review logic
    const branchQueries = branch.reduce((allQueries, { route }) => {
        const innerQueries = route.queries ? route.queries(params) : [];
        allQueries = [...innerQueries];
        return allQueries;
    }, []);

    const downloadableQueries = branchQueries?.filter(({ downloadable }) => downloadable);

    const repositoryNavigation = filteredNavigationByModulesForNestedLinks(
        modules || [],
        asideRepositoryNavigationByModule,
    );

    const _navigation = (route.navigation || []).map((item) => {
        if (item?.name === "label(Repository)") {
            delete item.to;
            item.navigation = [...repositoryNavigation];
        }

        return item;
    });

    const { navigation } = mapProperties(
        { navigation: _navigation },
        fetchResults,
        fetchStatus,
        Repository.queries({ ...params, fiscalYear, importId }),
        {
            ...props,
            ...navData,
        },
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    );

    const staticLinks = buildStaticLinks(
        navigation,
        history,
        { ...matchParams, fiscalYear, importId },
        i18n,
    );

    const goToSection = () => {
        const pop = history.action === "POP";
        setLocale(locale);
        if (!pop && !fetch.activity) {
            if (location.hash) {
                const scrollElement = window.document.querySelector(location.hash);
                if (scrollElement) {
                    const headerOffset = 70;

                    const previousRect =
                        scrollElement.previousElementSibling.getBoundingClientRect();
                    let stuckOffset = previousRect.height;
                    const elementPosition = scrollElement.offsetTop;
                    const offsetPosition = elementPosition - headerOffset - stuckOffset - 100;

                    setTimeout(() => {
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth",
                        });
                    }, 0);
                }
            } else if (location.search.search("page") === -1) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            }
        }
    };

    const goToSectionRef = useRef(goToSection);

    useEffect(() => {
        goToSectionRef.current();
    }, []);

    const organizationSelectedInMenu = (menuOrganizationProject || []).find(({ nestedAccounts }) =>
        (nestedAccounts || []).some(({ id }) => id === projectId),
    );

    const {
        accounts: fullOrganizationsWithProjects,
        selectedAccount: selectedOrganizationWithProjects,
    } = cleanPropertiesNestedInMenu(menuOrganizationProject, organizationSelectedInMenu);

    const navProps = BuildSovosNavProps(
        undefined,
        fullOrganizationsWithProjects,
        selectedOrganizationWithProjects,
        { locale, history, proxy, params: { ...params, fiscalYear, importId } },
        userInformation,
        staticLinks || [],
        projectId,
    );

    const redirect = redirectNotValid(userInformation, locale, false, auth);

    if (redirect) {
        return redirect;
    }

    if (match?.params?.urlRedir && (!queryStatus || queryStatus?.loading)) {
        return <LoadingPage />;
    }

    if (fiscalYear && fiscalYear !== "0000" && match?.params?.urlRedir) {
        return setAccount(project, locale, history, proxy, params);
    }

    if (!section) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (
        fiscalYear &&
        importId &&
        fiscalYears.length &&
        appContext === "repository" &&
        !(match?.url || "").match("\\d+/\\d+/\\d+/repository") &&
        !(match?.url || "").match("\\d+/\\d+/full/repository")
    ) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/${fiscalYear}/${importId}/repository/${section}${fileType ? "/" + fileType : ""}`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: Math.max(...fiscalYears),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    const globalLayoutProps = {
        ...props,
        navProps,
        downloadableQueries,
        params: { ...params, fiscalYear, importId },
        repositoryStatus,
        getTotalExportLines,
        staticLinks,
        styles,
    };

    return (
        <GlobalLayout {...globalLayoutProps}>
            <div className={styles["main"]}>
                <Connect to={["search", "downloading"]}>
                    {({ search, downloading }) => (
                        <div>
                            <RepositoryStatus modules={modules} />
                            <Header
                                filesList={filesList}
                                reportsAction
                                fiscalYears={fiscalYearsWithImportIds}
                                importIds={
                                    appContext === "repository" ? "" : importIdsFromUrlFiscalYear
                                }
                                downloadableQueries={downloadableQueries}
                                title={title ? i18n`${title}` : i18n`${params.section || ""}`}
                                downloading={downloading}
                                buttonConfigs={route?.buttonConfig}
                                totalLinesCsv={getTotalExportLines}
                            />
                        </div>
                    )}
                </Connect>
                <main className={`${styles["content"] || ""} ${styles["foreground"] || ""}`}>
                    {fetch.activity && (
                        <LoadingIndicator
                            className={`${styles["loading-indicator"]} ${
                                menu === "expanded" ? "" : styles["small-margin"]
                            }`}
                        />
                    )}
                    {children}
                    {route.routes && route.routes.length > 1 && (
                        <MainTabs
                            className={styles["tabs"]}
                            routes={route.routes}
                            params={matchParams}
                        />
                    )}
                    {renderRoutes(route.routes)}
                </main>
            </div>
        </GlobalLayout>
    );
};

Repository.queries = (args, userModulesByProject) => {
    const queries = filteredQueriesByModules(userModulesByProject);
    const deepCopyQueries = JSON.parse(JSON.stringify(queries));
    if (deepCopyQueries) {
        //needed to change arguments to the respective value
        deepCopyQueries.forEach((query) =>
            Object.keys(query.args).forEach((k) =>
                query.args[k] ? query.args[k] : (query.args[k] = args[k] || query.args[k]),
            ),
        );
    }

    const allQueries = [
        {
            resource: "menu_organizations_projects",

            body: "id,name,typeEntity,nestedAccounts{id,name,typeEntity}",
            forceRefresh: true,
        },
        {
            resource: "organization_projects_by_projectId",
            args: {
                projectId: args.projectId,
            },
            body: "id,name,maxFiscalYear,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,metadata,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive, maxFiscalYear",
            forceRefresh: true,
        },
        {
            resource: "application_version",
            body: "version",
        },
        {
            resource: "get_environment_to_subject",
        },
        {
            resource: "is_to_display_support_icon",
        },
        {
            resource: "get_limit_export",
        },
        {
            resource: "proxy_redirect_environment",
        },
        {
            resource: "folder_data",
            args: {
                projectId: args.projectId,
            },
            body: "fileType, fileTypeCount, fileTypeFiscalYears{fiscalYear,count}",
        },
        ...deepCopyQueries,
    ];
    if (userModulesByProject && userModulesByProject.includes("merge_collisions")) {
        allQueries.push({
            resource: "repository_status",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
            },
            body: "repoStatus,fiscalYear,fileType,autoMerge",
        });
    }

    return allQueries;
};

export default connect(
    ({ user, fetch, menu, uploads, auditNote }) => ({
        user,
        fetch,
        menu,
        uploads,
        auditNote,
    }),
    {
        logout,
        pushModal,
        popModal,
        removeModal,
        toggleMenu,
        setLocale,
        pushDialog,
        getFindingDetails,
        setDataFileStatus: setDataFileStatusAction,
        deleteFilePermanently: deleteFilePermanentlyAction,
        deleteGeneratorFileEntry: deleteGeneratorFileEntryAction,
        deleteInvalidFilePermanently: deleteInvalidFilePermanentlyAction,
        hideFile: hideFileAction,
        downloadFile: downloadFileAction,
        reprocessRepository: reprocessRepositoryAction,
        uploadFiles: uploadAction,
        submitTicket: submitTicketFormData,
        download: downloadAction,
        submitAuditNote: auditNoteSubmit,
        genericSearchAction,
        reprocessFiles: reprocessFileAction,
        getDownloadTemplateData,
        forceGenerateFile: forceGenerateFileAction
    },
)(withRouter(Repository));
